export const normalizeExternalUrl = (value: string) => {
    const sanitized = value.trim()
    if (!sanitized) return ''
    if (/^https?:\/\//i.test(sanitized)) return sanitized
    return `https://${sanitized}`
}
